import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as AdminDashboardTypes,
  Creators as AdminDashboardActions,
} from '../ducks/AdminDashboard';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getTopNumbers() {
  try {
    const { status, data } = yield call(api.get, '/admin-dashboard/top-numbers');

    if (status === 200) {
      yield put(AdminDashboardActions.getTopNumbersSuccess(data));
    } else {
      Sentry.captureMessage('getTopNumbers failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(AdminDashboardActions.getTopNumbersError('Error listing topnumbers'));
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(AdminDashboardActions.getTopNumbersError('Error listing topnumbers'));
  }
}
function* getMwhByYear() {
  try {
    const { status, data } = yield call(api.get, '/admin-dashboard/counted-mwh-by-year');

    if (status === 200) {
      yield put(AdminDashboardActions.getMwhByYearSuccess(data));
    } else {
      Sentry.captureMessage('getMwhByYear failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(AdminDashboardActions.getMwhByYearError("Error listing mwh's by year"));
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(AdminDashboardActions.getMwhByYearError("Error listing mwh's by year"));
  }
}

function* getBusinessByTechnology() {
  try {
    const { status, data } = yield call(api.get, '/admin-dashboard/businesses-by-technology');

    if (status === 200) {
      yield put(AdminDashboardActions.getBusinessByTechnologySuccess({ data }));
    } else {
      Sentry.captureMessage('getBusinessByTechnology failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(AdminDashboardActions.getBusinessByTechnologyError('Error listing projects by technology'));
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(AdminDashboardActions.getBusinessByTechnologyError('Error listing projects by technology'));
  }
}

function* getApprovedRecsByEmission() {
  try {
    const { status, data } = yield call(api.get, '/admin-dashboard/approved-recs-by-emission-month');

    if (status === 200) {
      yield put(AdminDashboardActions.getApprovedRecsByEmissionSuccess(data));
    } else {
      Sentry.captureMessage('getApprovedRecsByEmission failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(AdminDashboardActions.getApprovedRecsByEmissionError('Error listing approved recs by issue date'));
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(AdminDashboardActions.getApprovedRecsByEmissionError('Error listing approved recs by issue date'));
  }
}

function* getApprovedRecsByProduction() {
  try {
    const { status, data } = yield call(api.get, '/admin-dashboard/approved-recs-by-production-month');

    if (status === 200) {
      yield put(AdminDashboardActions.getApprovedRecsByProductionSuccess(data));
    } else {
      Sentry.captureMessage('getApprovedRecsByProduction failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(AdminDashboardActions.getApprovedRecsByProductionError('Error listing approved recs by production date'));
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(AdminDashboardActions.getApprovedRecsByProductionError('Error listing approved recs by production date'));
  }
}

function* getTopNumbersWatcher() {
  yield takeLatest(AdminDashboardTypes.GET_TOP_NUMBERS, getTopNumbers);
}

function* getMwhByYearWatcher() {
  yield takeLatest(AdminDashboardTypes.GET_MWH_BY_YEAR, getMwhByYear);
}

function* getBusinessByTechnologyWatcher() {
  yield takeLatest(
    AdminDashboardTypes.GET_BUSINESS_BY_TECHNOLOGY,
    getBusinessByTechnology
  );
}

function* getApprovedRecsByEmissionWatcher() {
  yield takeLatest(
    AdminDashboardTypes.GET_APPROVED_RECS_BY_EMISSION,
    getApprovedRecsByEmission
  );
}

function* getApprovedRecsByProductionWatcher() {
  yield takeLatest(
    AdminDashboardTypes.GET_APPROVED_RECS_BY_PRODUCTION,
    getApprovedRecsByProduction
  );
}

export default function* rootSaga() {
  yield all([
    fork(getTopNumbersWatcher),
    fork(getMwhByYearWatcher),
    fork(getBusinessByTechnologyWatcher),
    fork(getApprovedRecsByEmissionWatcher),
    fork(getApprovedRecsByProductionWatcher),
  ]);
}
